import { AppBar, Toolbar, Typography, IconButton, Badge, Avatar, Menu, MenuItem, useMediaQuery, useTheme } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageURL from '../../constants/PageURL';

const Header = ({open:sidebarOpen}) => {
     const { user, error, loadingUser } = useSelector((state) => state.user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const navigate=useNavigate()

  return (
    <AppBar 
      position="static" 
      sx={{ 
        backgroundColor: '#203864', // Dark blue background
        color: 'white', // White text for contrast
        boxShadow: 'none',
        // padding: '0 10px'
       position: 'sticky', top: 0, zIndex: 1100 ,
      }}
    >
      <Toolbar sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        padding: '8px 0'
      }}>
        
        {/* Left side - Text */}
        <Typography 
          variant="h6" 
          component="div" 
          sx={{
            fontWeight: 600,
            fontSize: "1.15rem",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: isMobile ? '180px' : 'none',
            color: 'white',
            marginLeft:!sidebarOpen?isMobile?"3rem":"1.5rem":"0rem"

          }}
        >
          Creating A Better World In a Changing Climate
        </Typography>

        {/* Right side - Icons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {/* Notification Icon */}
          {/* <IconButton 
            color="inherit" 
            aria-label="notifications"
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)', // Light hover effect
              }
            }}
            onClick={()=>navigate(PageURL.NOTIFICATOIN)}
          >
            <Badge badgeContent={1} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}

          {/* Profile Section */}
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              cursor: 'pointer'
            }}
            onClick={handleProfileMenuOpen}
          >
            <Avatar 
              sx={{ 
                width: 32, 
                height: 32,
                backgroundColor: '#4a6baf', // Complementary lighter blue
                color: 'white',
                fontSize: '0.875rem',
                '&:hover': {
                  backgroundColor: '#5c7bc1' // Slightly lighter on hover
                }
              }}
            >
             {user?.userName?.substr(0,2)?.toUpperCase()}
            </Avatar>
            {!isMobile && (
              <Typography variant="body1" sx={{ fontWeight: 400, color: 'white' }}>
                {`${user?.userName?.substr(0,8)}...`}
              </Typography>
            )}
          </div>

          {/* Profile Menu */}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiPaper-root': {
                marginTop: '8px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                minWidth: '200px',
                backgroundColor: '#f5f7fa' // Light gray background for menu
              }
            }}
          >
            {/* <MenuItem onClick={handleMenuClose} sx={{ color: '#203864' }}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose} sx={{ color: '#203864' }}>Settings</MenuItem> */}
            {/* <MenuItem onClick={handleMenuClose} sx={{ color: '#203864' }}>Logout</MenuItem> */}
            <MenuItem sx={{ color: '#203864' }}>{user?.userName}</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;